import React, { useState, useEffect, useRef } from "react";
import "../../Components/viewClinicProfile/profile.css";
import moment from "moment";
import strings from "../../Utils/strings";
import Widgets from "../../Widgets";
import { t } from "../../Utils/translate";
import clinicService from "../../Services/clinicService";
import authService from "../../Services/authService";

function DoctorProfileDetails({ randomRefresher, doctorInfo }) {
  const [schedule, setSchedule] = useState(false);
  const [holiday, setHoliday] = useState(false);
  const [holidayList, setHolidayList] = useState([]);
  const [doctorUpdateTiming, setDoctorUpdateTiming] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const hasFetchedLeave = useRef(false);
  const [isDoctorLogin, setIsDoctorLogin] = useState(false);
  const isFetched = useRef(false);

  useEffect(() => {
    setDoctorUpdateTiming(doctorInfo.openingHoursSpecification);
  }, [randomRefresher, doctorInfo]);

  useEffect(() => {
    setIsDoctorLogin(authService.getIsDoctorLogin() === "true");
  }, []);
  useEffect(() => {
    if (!isFetched.current) {
      isFetched.current = true;
      getDoctorLeave();
    }
  }, [isDoctorLogin]);

  const getDoctorLeave = async () => {
    setIsLoading(true);
    try {
      let response;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.docGetLeavelist();
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.getDoctorLeave(doctorInfo._id);
      }
      if (response.status === "success") {
        setHolidayList(response?.data?.leaves);
      } else {
        console.log("Hospital does not exist");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      {isLoading ? (
        <Widgets.CircularLoader />
      ) : (
        <div className="view-clinic-profile-details">
          <div className="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                {schedule ? (
                  <button
                    onClick={() => {
                      setSchedule(!schedule);
                    }}
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="true"
                    aria-controls="flush-collapseOne"
                  >
                    {t("labelSchedule")}
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      setSchedule(!schedule);
                    }}
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                  >
                    {t("labelSchedule")}
                  </button>
                )}
              </h2>
              {schedule ? (
                <div className="accordion-body">
                  <div>
                    {doctorUpdateTiming && doctorUpdateTiming.length > 0 ? (
                      <div className="row col-12">
                        {doctorUpdateTiming.map((details) => (
                          <div className="col days col-md-6 col-sm-6 col-lg-3" key={details._id}>
                            <h3 className="week-days"> {t(details.dayOfWeek)}</h3>
                            <div className="row">
                              <div className="timing">
                                {details.sessions.length > 0 ? (
                                  details.sessions.map((time) => {
                                    const opens = moment(time.opens, "HH:mm").format("HH:mm");
                                    const closes = moment(time.closes, "HH:mm").format("HH:mm");
                                    return (
                                      <div className="col mt-1 text-nowrap" key={time._id}>
                                        {opens}
                                        <span className="to mt-1 text-nowrap">{t("labelTo")}</span>
                                        {closes}
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="col mt-1 text-nowrap">{t("Closed")}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </div>
            {holidayList.length !== 0 ? (
              <div className="accordion-item mt-2">
                <h2 className="accordion-header" id="flush-headingOne">
                  {holiday ? (
                    <button
                      onClick={() => {
                        setHoliday(!holiday);
                      }}
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                    >
                      {t("labelLeaveSchedule")}
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        setHoliday(!holiday);
                      }}
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                    >
                      {t("labelLeaveSchedule")}
                    </button>
                  )}
                </h2>
                {holiday ? (
                  <div className="accordion-body">
                    {holidayList.map((item, i) => {
                      // const formattedDate = moment(item.date, strings.format.formatDate).format(strings.format.month);
                      return (
                        <button type="button" className="btn btn-danger me-1 mt-1" key={i}>
                          {item.date}
                        </button>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
}

export default DoctorProfileDetails;
